import { useEffect } from "react";
import type { StoreDocuments } from "../../StoreDocuments";
import type { StoreContractForm } from "./StoreContractForm";

export const useOptions = (
  store: StoreContractForm,
  documentsStore: StoreDocuments | null,
) => {
  useEffect(() => {
    store.projectOptions = documentsStore?.projects ?? [];
    store.clientOptions = documentsStore?.clients ?? [];
    store.contractorOptions = documentsStore?.contractors ?? [];
    store.brandOptions = documentsStore?.brands ?? [];
  }, [
    documentsStore?.projects,
    documentsStore?.clients,
    documentsStore?.contractors,
    documentsStore?.brands,
  ]);
};
